var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "moduleAssignment-content" },
    [
      _c("div", { staticClass: "module-header" }, [
        _c("h1", {
          staticClass: "wk_headline",
          domProps: { textContent: _vm._s(_vm.localize("moduleAssignment")) },
        }),
      ]),
      _vm._v(" "),
      _c("p", {
        staticClass: "module-body-header",
        domProps: { textContent: _vm._s(_vm.localize("moduleAssignmentBody")) },
      }),
      _vm._v(" "),
      _c("DxLoadPanel", {
        attrs: {
          position: _vm.position,
          visible: _vm.loadingVisible,
          "show-indicator": _vm.showIndicator,
          "show-pane": _vm.showPane,
          shading: _vm.shading,
          "shading-color": "rgba(255,255,255,.8)",
        },
      }),
      _vm._v(" "),
      [
        _c(
          "div",
          { attrs: { id: "assign-copmany-popup" } },
          [
            _c(
              "DxPopup",
              {
                attrs: {
                  visible: _vm.popupVisible,
                  "show-title": true,
                  height: 540,
                  width: "50%",
                  "show-close-button": false,
                  title: _vm.localize("moduleAssigningCompaniesHeader"),
                },
              },
              [
                _c("DxToolbarItem", {
                  attrs: {
                    widget: "dxButton",
                    toolbar: "top",
                    location: "after",
                    options: _vm.closeButtonOptions,
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "company-lists-area" }, [
                  _c(
                    "div",
                    { staticClass: "company-list-area-col" },
                    [
                      [
                        _c("div", [
                          _vm.currentModule && _vm.currentModule.moduledefid
                            ? _c(
                                "div",
                                { staticClass: "list-container" },
                                [
                                  _c(
                                    "h5",
                                    { staticClass: "mb-3 column-header" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.localize(
                                            "moduleAssignExistingCompanies"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("DxList", {
                                    attrs: {
                                      "data-source": _vm.unAssigned,
                                      height: 400,
                                      "search-enabled": true,
                                      "search-mode": _vm.searchMode,
                                      "indicate-loading": true,
                                      "selection-mode": "single",
                                      "selected-items": [],
                                      "key-expr": "id",
                                      "search-expr": "name",
                                    },
                                    on: {
                                      "item-click": _vm.getCompanyUnAssignments,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "item",
                                          fn: function ({ data }) {
                                            return [
                                              _c("div", [
                                                _c("div", [
                                                  _vm._v(_vm._s(data.name)),
                                                ]),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1584141574
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                      ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "company-list-area-col" }, [
                    _c("div", { staticClass: "switcher" }, [
                      _c(
                        "div",
                        { staticClass: "swithcer-unassign" },
                        [
                          _c("DxButton", {
                            attrs: {
                              type: "default",
                              disabled: !_vm.unAssignedCurrentCompany,
                              icon: "chevronright",
                              "use-submit-behavior": false,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.companyAssignments(
                                  _vm.unAssignedCurrentCompany
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "swithcer-assign" },
                        [
                          _c("DxButton", {
                            attrs: {
                              type: "default",
                              disabled: !_vm.assignedCurrentCompany,
                              icon: "chevronleft",
                              "use-submit-behavior": false,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.companyAssignments(
                                  _vm.assignedCurrentCompany
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "company-list-area-col" },
                    [
                      [
                        _c("div", [
                          _vm.currentModule && _vm.currentModule.moduledefid
                            ? _c(
                                "div",
                                { staticClass: "list-container" },
                                [
                                  _c(
                                    "h5",
                                    { staticClass: "mb-3 column-header" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.localize(
                                            "moduleAssignedCompanies"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("DxList", {
                                    attrs: {
                                      "data-source": _vm.assigned,
                                      height: 400,
                                      "search-enabled": true,
                                      "search-mode": _vm.searchMode,
                                      "indicate-loading": true,
                                      "selection-mode": "single",
                                      "selected-items": [],
                                      "key-expr": "id",
                                      "search-expr": "name",
                                    },
                                    on: {
                                      "item-click": _vm.getCompanyAssignments,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "item",
                                          fn: function ({ data }) {
                                            return [
                                              _c("div", [
                                                _c("div", [
                                                  _vm._v(_vm._s(data.name)),
                                                ]),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1584141574
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                      ],
                    ],
                    2
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ],
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid-top" },
        [
          _c(
            "DxDataGrid",
            {
              attrs: {
                "data-source": _vm.modulesDataSource,
                "row-alternation-enabled": true,
                "show-row-lines": true,
                "show-borders": true,
                "column-auto-width": true,
                "key-expr": "generalmoddefid",
              },
              scopedSlots: _vm._u([
                {
                  key: "module-name",
                  fn: function ({ data }) {
                    return [
                      _c("span", [
                        _vm._v(_vm._s(data.data.generalmoddef.friendlyname)),
                      ]),
                    ]
                  },
                },
                {
                  key: "all-companies-assignments",
                  fn: function ({ data }) {
                    return [
                      _c("DxCheckBox", {
                        attrs: {
                          value: data.data.moduleAcessConfig.allowAllCompanies,
                          mode: "multiple",
                        },
                        on: {
                          "value-changed": function ($event) {
                            return _vm.allCompaniesAssignments(data.data)
                          },
                        },
                      }),
                    ]
                  },
                },
                {
                  key: "assign-company-template",
                  fn: function ({ data }) {
                    return [
                      _c("DxButton", {
                        attrs: {
                          disabled:
                            data.data.moduleAcessConfig.allowAllCompanies,
                          type: "default",
                          "styling-mode": "contained",
                          text: _vm.localize("moduleAssignToCompanyBtn"),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.getModuleCompany(data.data)
                          },
                        },
                      }),
                    ]
                  },
                },
              ]),
            },
            [
              _c("DxPaging", { attrs: { "page-size": 10 } }),
              _vm._v(" "),
              _c("DxPager", {
                attrs: {
                  visible: true,
                  "allowed-page-sizes": [10, 20, 50],
                  "show-page-size-selector": true,
                  "show-navigation-buttons": true,
                },
              }),
              _vm._v(" "),
              _c("DxColumn", {
                staticClass: "grid-content",
                attrs: {
                  caption: _vm.localize("moudleAssignName"),
                  "cell-template": "module-name",
                },
              }),
              _vm._v(" "),
              _vm._v(" "),
              _c("DxColumn", {
                attrs: {
                  caption: _vm.localize("moduleAssignAllCompanies"),
                  "cell-template": "all-companies-assignments",
                },
              }),
              _vm._v(" "),
              _vm._v(" "),
              _c("DxColumn", {
                attrs: {
                  caption: _vm.localize("moduleAssignToCompany"),
                  "cell-template": "assign-company-template",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }